'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarTotalFooter(props) {
  var components = props.components,
      rate = props.rate,
      rateCurrency = props.rateCurrency,
      rateType = props.rateType,
      total = props.total,
      totalCurrency = props.totalCurrency,
      rateperdistanceunits = props.rateperdistanceunits,
      rateperdistance = props.rateperdistance,
      rateperdistancecurrency = props.rateperdistancecurrency,
      selectedCurrencyFormat = props.selectedCurrencyFormat,
      t = props.t;


  var styleTotalContainer = (0, _emailStyleTools.containerStyles)(components, 'TotalContainer');
  var styleDailyRateTitleLabel = (0, _emailStyleTools.textStyles)(components, 'DailyRateTitleLabel');
  var styleDailyRateValueLabel = (0, _emailStyleTools.textStyles)(components, 'DailyRateValueLabel');
  var styleApproximateTotalValueLabel = (0, _emailStyleTools.textStyles)(components, 'ApproximateTotalValueLabel');
  var styleApproximateTotalTitleLabel = (0, _emailStyleTools.textStyles)(components, 'ApproximateTotalTitleLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'CarTotalFooter' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleTotalContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'table',
            { style: _emailStyleTools.fullMinimal, 'data-component': 'CarTotalFooter__Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { verticalAlign: 'top', padding: '0', width: '70%' } },
                  _react2.default.createElement(
                    'span',
                    { style: styleDailyRateTitleLabel },
                    rateType,
                    ':'
                  ),
                  _react2.default.createElement('span', null),
                  _react2.default.createElement(
                    'span',
                    { style: styleDailyRateValueLabel },
                    (0, _priceString2.default)(selectedCurrencyFormat, rate, rateCurrency)
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'span',
                    { style: styleDailyRateTitleLabel },
                    t('car.charge'),
                    ' ',
                    rateperdistanceunits,
                    ':'
                  ),
                  _react2.default.createElement('span', null),
                  _react2.default.createElement(
                    'span',
                    { style: styleDailyRateValueLabel },
                    (0, _priceString2.default)(selectedCurrencyFormat, rateperdistance, rateperdistancecurrency)
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { style: { verticalAlign: 'top', padding: '0', textAlign: 'right', width: '30%' } },
                  _react2.default.createElement(
                    'table',
                    { style: _emailStyleTools.fullMinimal, 'data-component': 'CarTotalFooter__Total' },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: _emailStyleTools.noPad },
                          _react2.default.createElement(
                            'span',
                            { style: styleApproximateTotalValueLabel },
                            (0, _priceString2.default)(selectedCurrencyFormat, total, totalCurrency)
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: _emailStyleTools.noPad },
                          _react2.default.createElement(
                            'span',
                            { style: styleApproximateTotalTitleLabel },
                            t('car.total')
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  var basketCurrencyFormat = state.rendering.shopOptions.currencyFormat;
  return {
    selectedCurrencyFormat: basketCurrencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(CarTotalFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Active/CarTotalFooter.jsx
// module id = 1497
// module chunks = 0